module.exports = __webpack_public_path__ + "images/cebsb_logo.1785317263746.png";